const comments = [
  {
    name: '电影发烧友小林',
    text: '窝窝影院真的是我用过最好的免费观影平台！高清播放在线不缓冲，再也不用等加载了。而且完全没有广告，流畅观看超清画质太爽了。已经推荐给身边所有朋友了！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20man%20with%20friendly%20smile%2C%20warm%20natural%20lighting%2C%20clean%20white%20background%2C%20headshot%20photography%2C%20casual%20style&width=120&height=120&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '追剧达人阿静',
    text: '每天下班第一件事就是打开窝窝影院追更新！海量高清电影电视剧免费在线观看，连我妈都被我安利了。每日更新不卡顿这个是真的强，新剧基本第二天就有了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20headshot%20photography%2C%20friendly%20expression&width=120&height=120&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '影评人老周',
    text: '作为一名影评人，我对画质要求很高。窝窝影院的超清画质真的惊艳到我了，很多老片子都有修复版，色彩还原度极高。无广告的纯净观影体验在免费平台中实属难得。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle-aged%20Chinese%20man%20with%20glasses%2C%20thoughtful%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20headshot%20photography%2C%20professional%20style&width=120&height=120&seq=avatar-user-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            用户评价
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            听听他们怎么说
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 md:p-7 relative"
            >
              <div className="absolute top-5 right-6 text-5xl text-background-300 font-serif leading-none select-none">
                &ldquo;
              </div>
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-10 h-10 rounded-full object-cover"
                    title={c.name}
                  />
                  <span className="font-semibold text-foreground-900 text-sm">
                    {c.name}
                  </span>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {c.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}